module.exports = __webpack_public_path__ + "img/Large-2-Bevel-Attachment-48.ca9be873.png";